import { createClass as _createClass, classCallCheck as _classCallCheck } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { CachedTotalWidth as CachedTotalWidth$1 } from './util/dom/CachedTotalWidth.js';
import { CachedCSSProperty as CachedCSSProperty$1 } from './util/dom/CachedCSSProperty.js';
import { CachedDOMMeasurements as CachedDOMMeasurements$1 } from './util/dom/CachedDOMMeasurements.js';
import { CachedTotalWidths as CachedTotalWidths$1 } from './util/dom/CachedTotalWidths.js';

var FilmstripItemVisibility;

(function (FilmstripItemVisibility) {
  FilmstripItemVisibility["visible"] = "visible";
  FilmstripItemVisibility["hidden"] = "hidden";
  FilmstripItemVisibility["partial"] = "partial";
})(FilmstripItemVisibility || (FilmstripItemVisibility = {}));

var ItemTracker = /*#__PURE__*/function () {
  function ItemTracker(
  /* the parent element of the items to track */
  // private readonly filmstrip: FilmstripController
  itemElements) {
    var _this = this;

    var calculateAllItemWidths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, ItemTracker);

    this.itemElements = itemElements;
    this.calculateAllItemWidths = calculateAllItemWidths;
    /** Keep track of item dimensions. It's our job */

    this.measurements = new CachedDOMMeasurements$1({
      itemWidth: new CachedTotalWidth$1(function () {
        return _this.firstRegularItem;
      }, 100),
      itemSpacing: new CachedCSSProperty$1('--item-spacing', function () {
        return _this.startEndcapItem;
      }, 8),
      startEndcapWidth: new CachedTotalWidth$1(function () {
        return _this.startEndcapItem;
      }, 100)
    });
    /** Validate that an item index is acceptable and within bounds */

    this.isValidItemIndex = function (i) {
      return Number.isFinite(i) && i >= 0 && i < _this.virtualItems;
    };
  }
  /** Clear all cached dom measurements */


  _createClass(ItemTracker, [{
    key: "clearCache",
    value: function clearCache() {
      this.measurements.clear();
    }
  }, {
    key: "getItemWidth",

    /** Measure a single item */
    value: function getItemWidth(index) {
      if (!this.calculateAllItemWidths) return undefined;
      if (this.allItemWidths === undefined) this.allItemWidths = new CachedTotalWidths$1();
      return this.allItemWidths.add(this.itemElements[index]);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var measurements = this.measurements,
          virtualItems = this.virtualItems,
          renderedItems = this.renderedItems,
          allItemWidths = this.allItemWidths;
      return {
        measurements: measurements.toJSON(),
        allItemWidths: allItemWidths === null || allItemWidths === void 0 ? void 0 : allItemWidths.toJSON(),
        virtualItems: virtualItems,
        renderedItems: renderedItems
      };
    }
  }, {
    key: "virtualItems",
    get: function get() {
      var _a;

      return (_a = this._virtualItems) !== null && _a !== void 0 ? _a : this.renderedItems;
    },
    set: function set(total) {
      this._virtualItems = total;
    }
    /** Grab the "endcap item", which may be of a different width than other items. NOTE: this check
    occurs before the nav buttons are added in */

  }, {
    key: "startEndcapItem",
    get: function get() {
      return this.all[0];
    }
    /** Grab the first "regular item", which can be safely used to judge the dimensions of the typical
    item, since we require that all items except endcaps are uniform in size. */

  }, {
    key: "firstRegularItem",
    get: function get() {
      return this.all[1] || this.all[0];
    }
  }, {
    key: "hasEndcap",
    get: function get() {
      return this.endcapDifferential !== 0;
    }
  }, {
    key: "endcapDifferential",
    get: function get() {
      return this.measurements.get('startEndcapWidth') - this.measurements.get('itemWidth');
    }
    /* eslint-disable unicorn/prefer-spread */

  }, {
    key: "all",
    get: function get() {
      // If the nav buttons are in the Shadow DOM, this is all we need!
      return Array.from(this.itemElements);
    }
  }, {
    key: "renderedItems",
    get: function get() {
      return this.itemElements.length;
    }
  }, {
    key: "lastIndex",
    get: function get() {
      return this.virtualItems - 1;
    }
  }, {
    key: "filmstripIsEmpty",
    get: function get() {
      return this.renderedItems === 0;
    }
  }]);

  return ItemTracker;
}();

export { FilmstripItemVisibility, ItemTracker };
